import styled from "styled-components";

import {
  Box,
  FlexContainer,
  FlexDiv,
  FlexSection,
} from "@/components/Atoms/Box";

import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";

export const GradientSection = styled(FlexSection)`
  background-color: ${theme.colorsV2.shyft.cream};
  padding: 80px 0;
  box-shadow: 0px 10px 20px rgba(${theme.colors.shadows.black}, 0.04),
    0px 2px 6px rgba(${theme.colors.shadows.black}, 0.04),
    0px 0px 1px rgba(${theme.colors.shadows.black}, 0.04);
  @media only screen and (max-width: 1079px) {
    padding: 40px 0 32px;
  }
`;

export const LHSSection = styled(FlexDiv)`
  width: 100%;
  height: 100%;
  justify-content: center;
  flex: 1;
  padding: 12px 16px;
  position: relative;
  @media only screen and (max-width: 1079px) {
    max-width: 100%;
    padding: 16px;
    margin-bottom: 24px;
  }
`;

export const LogoBox = styled(FlexDiv)`
  align-items: center;
`;

export const DynamicContentHtml = styled(Typography)`
  span {
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }
  .pink_text {
    color: ${theme.colorsV2.pink.shade_600};
  }
  .purple_text {
    color: ${theme.colorsV2.primary.shade_700};
  }
`;

export const FormBox = styled(FlexDiv)`
  background-color: ${theme.colors.white};
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid ${theme.colorsV2.blueGray.shade_100};
  width: 100%;
  box-shadow: 0px 10px 20px rgba(${theme.colors.shadows.black}, 0.04),
    0px 2px 6px rgba(${theme.colors.shadows.black}, 0.04),
    0px 0px 1px rgba(${theme.colors.shadows.black}, 0.04);
  @media only screen and (max-width: 1079px) {
    max-width: 545px;
    margin: 0 auto;
  }
`;

export const RHSSection = styled(FlexDiv)`
  position: relative;
  flex: 1;
  padding: 0 24px;
  max-width: 504px;
  height: 100%;
  align-items: center;
  width: 100%;
  @media only screen and (max-width: 1079px) {
    padding: 0 8px;
    margin: 0 auto;
  }
`;

export const BlueBox = styled(FlexDiv)`
  padding: 32px 48px 24px 32px;
  background-color: ${theme.colorsV2.shyft.purple_text};
  @media only screen and (max-width: 1079px) {
    padding: 16px 32px;
  }
`;

export const FormFieldBox = styled(FlexDiv)`
  flex-direction: column;
  padding: 32px;
  flex: 1;
  @media only screen and (max-width: 1079px) {
    padding: 24px;
  }
`;

export const TopContainer = styled(FlexContainer)`
  position: relative;
  @media only screen and (max-width: 1079px) {
    flex-direction: column;
    padding: 0;
  }
`;

export const TextAreaBox = styled(FlexDiv)`
  padding-top: 24px;
`;

export const IconRing = styled(Box)`
  height: 72px;
  width: 72px;
  border-radius: 50%;
  background-color: ${theme.colors.shadeRed};
  overflow: hidden;
`;

export const StyledSeparator = styled(Box)`
  height: 40px;
  width: 1px;
  background-color: #ccc;
  margin-right: 8px;
`;
